import { autoinject, transient, computedFrom } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { GhgVerificationClientModel, GhgVerificationEnergySavingEquipmentModel } from "../../../../../../models/ghgs/ghg.models";
import { UserClientService } from "../../../../../../services/authentication/user-client.service";
import { GhgService } from "../../../../../../services/ghg/ghg.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";

@autoinject()
@transient()
export class GhgEnergySavingEquipmentCommentsDialog {

    ghgEnergySavingEquipment: GhgVerificationEnergySavingEquipmentModel;
    customerId: number;
    ghgVerification: GhgVerificationClientModel;
    originalComments: string;

    @computedFrom('ghgVerification.isClosed', 'customerId')
    public get canSave() {
        return this.ghgVerification && !this.ghgVerification.isClosed && !this.customerId;
    }

    public constructor(private dialogClientService: DialogClientService,
        private ghgService: GhgService,
        private userClientService: UserClientService,
        private notificationClientService: NotificationClientService) {
        this.customerId = this.userClientService.currentUser.settings.customerId;
    }

    activate(model: { ghgVerification: GhgVerificationClientModel, ghgEnergySavingEquipment: GhgVerificationEnergySavingEquipmentModel }) {
        this.ghgEnergySavingEquipment = model.ghgEnergySavingEquipment;
        this.ghgVerification = model.ghgVerification;
        this.originalComments = this.ghgEnergySavingEquipment.ghgRatingFactorSourceComment;
    }

    close() {
        this.ghgEnergySavingEquipment.ghgRatingFactorSourceComment = this.originalComments;
        this.dialogClientService.hide();
    }

    done() {
        return new Promise<void>((resolve, reject) => {
            this.ghgService.saveGhgEnergySavingEquipmentComment({
                ghgRatingFactorSourceComment: this.ghgEnergySavingEquipment.ghgRatingFactorSourceComment,
                ghgVerificationId: this.ghgVerification.ghgVerificationId,
                ghgVerificationEnergySavingEquipmentId: this.ghgEnergySavingEquipment.ghgVerificationEnergySavingEquipmentId
            }).then(() => {
                this.dialogClientService.hide();
                resolve();
            }).catch(() => {
                this.notificationClientService.show("Failed to save Rating Factor comments", "", NotificationType.Error);
                reject();
            });
        });
    }
}
